import React from 'react';
import { mui } from '@local/finsera-core/src/libs';
import * as types from '@local/finsera-core/src/types';

import RelaxOrder from './relax-order';
import ContextSingleton from '../../../__singletons__/context-singleton';
import FinDatePicker from '../../date-picker';

type SharedConstraintsProps = {
  params: types.optimizer.ConstraintDraft;
  showRelaxation?: boolean;
  setParams: (_params: types.optimizer.ConstraintDraft & { constraint_type?: any }) => void;
  disableAll?: boolean;
  id?: string;
  readOnly: boolean;
  validationDef: types.common.ValidationErrors;
};

const SharedConstraintFields = ({
  params,
  setParams,
  showRelaxation = true,
  disableAll,
  id,
  readOnly,
  validationDef,
}: SharedConstraintsProps) => {
  const features = ContextSingleton.getInstance().features;
  const theme = mui.styles.useTheme() as mui.core.Theme;

  return (
    <>
      <mui.core.Grid container spacing={4} rowSpacing={3} style={{ marginTop: theme.spacing(2) }}>
        <mui.core.Grid size={{ xs: 12, md: 6 }}>
          <FinDatePicker
            label="Start Date"
            clearable
            fullWidth
            value={params.start}
            onChange={(date: string) => setParams({ ...params, start: date })}
            disabled={readOnly || disableAll}
            inputVariant="outlined"
            size="small"
            minDate={features.start_date}
            maxDate={params.end ? params.end : features.end_date}
            error={validationDef?.fields?.includes(`start_date_${id}`)}
          />
        </mui.core.Grid>

        <mui.core.Grid size={{ xs: 12, md: 6 }}>
          <FinDatePicker
            label="End Date"
            clearable
            fullWidth
            value={params.end}
            onChange={(date: string) => setParams({ ...params, end: date })}
            disabled={readOnly || disableAll}
            inputVariant="outlined"
            size="small"
            minDate={params.start ? params.start : features.start_date}
            maxDate={features.end_date}
            error={validationDef?.fields?.includes(`end_date_${id}`)}
          />
        </mui.core.Grid>
      </mui.core.Grid>
      {showRelaxation && (
        <mui.core.Grid container spacing={4} style={{ marginTop: theme.spacing(1) }}>
          <RelaxOrder params={params} setParams={setParams} disabled={readOnly || disableAll} />
        </mui.core.Grid>
      )}
    </>
  );
};

export default SharedConstraintFields;
